import { Extension } from "@tiptap/core";

/**
 * Keeps the presentational HTML attributes that the stored documents carry on
 * their tables.
 *
 * Tiptap's schema drops any attribute a node does not declare, silently and on
 * save. The order sheet and the notices depend on two that it does not declare:
 *
 *   <table border="1">          the 30/70 column CSS is scoped to table[border],
 *                               and bac/html_docx.py reads it to decide whether
 *                               to draw cell borders in the .docx
 *   <td style="width: 30%">     the column split itself
 *
 * Without this extension both disappear on the first save and the order sheet
 * silently reflows - which is the failure mode a schema-based editor is most
 * likely to produce and the least likely to be noticed in review.
 */
export const TableAttributes = Extension.create({
  name: "tableAttributes",

  addOptions() {
    return {
      types: ["table", "tableRow", "tableCell", "tableHeader"],
      attributes: [
        "style",
        "border",
        "width",
        "height",
        "align",
        "valign",
        "cellpadding",
        "cellspacing",
        "bgcolor",
      ],
    };
  },

  addGlobalAttributes() {
    const attributes = {};

    this.options.attributes.forEach((name) => {
      attributes[name] = {
        default: null,
        parseHTML: (element) => element.getAttribute(name),
        // mergeAttributes merges `style` declaration by declaration, so this
        // sits alongside text-align and the table extension's own widths
        // rather than overwriting them.
        renderHTML: (attrs) => (attrs[name] ? { [name]: attrs[name] } : {}),
      };
    });

    return [{ types: this.options.types, attributes }];
  },
});

export default TableAttributes;
